import * as apiPostProduct from 'api/erp/PostProduct';
import * as Product from 'types/Ingredient/Detail/OrderGuide/Product';

export * as Product from 'types/Ingredient/Detail/OrderGuide/Product';

export type Type = {
	priority?: number;
	productId: string;
	sourceId: string;
	imageUrl: string;
	name: string;
	price: number;
	gtin: string;
	ingredientId: string;
	externalUrl: string;
	size: string;
};

export function create(): Type {
	return {
		productId: '',
		sourceId: '',
		imageUrl: '',
		name: '',
		price: 0,
		gtin: '',
		ingredientId: '',
		externalUrl: '',
		size: '',
	};
}
export function mapFromApiPost(e: { priority: number; productId: string; sourceId: string }): Type {
	return {
		...create(),
		priority: e.priority,
		productId: e.productId,
		sourceId: e.sourceId,
	};
}

export function mergeWithProducts(obj: Type, product: Product.Type): Type {
	return {
		...obj,
		...product,
		imageUrl: product.imageUrl,
		price: product.price ?? 0,
		gtin: product.gtin,
		externalUrl: product.externalUrl,
	};
}

export function mapFromApi(
	product: apiPostProduct.ResponseData[string],
	productId: string,
	sourceId: string
): Type {
	return {
		...create(),
		...product,
		productId: productId,
		sourceId: sourceId,
		imageUrl: product.imageUrl ?? '',
		name: product.name ?? '',
		price: product.price ?? 0,
		gtin: product.externalId ?? '',
		externalUrl: product.externalUrl ?? '',
		size: product.volume ? product.volume.toString() : '',
	};
}
export function togglePriority(e: Type, priority: number): Type {
	if (e.priority === priority) return { ...e, priority: undefined };
	return {
		...e,
		priority: priority,
	};
}

export function setPriority(obj: Product.Type, priority: number): any {
	return { ...obj, priority: obj.priority === priority ? undefined : priority };
}
